import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import MaterialTable from "material-table";

//Context
import { useAuth } from "../../../context/auth";
import { showMessage, showQuestion } from "../../../services/message";

//API
import { api_DELETE, api_GET, api_PUT } from "../../../services/api_service";
import { api_POST } from "../../../services/api_service";

//Constants
import { table_translate } from "../../../constants/MaterialTable";
import { table_style } from "../../../constants/MaterialTable";

export default function PlanoResiduoDetalhamento({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { session, setLoading } = useAuth();
  const [registro, setRegistro] = useState(null);
  const [permiteEditar, set_permiteEditar] = useState(true);
  const [optionsClassesResiduo, set_OptionsClassesResiduo] = useState([]);
  const [detalhamentosLista, setDetalhamentosLista] = useState([]);

  const [optionsArmazenamentoObra] = useState([
    { label: "SELECIONE", value: "0" },
    {
      label: "Agranel em piso impermeável, área coberta (baia)",
      value: "Agranel em piso impermeável, área coberta (baia)",
    },
    {
      label: "Agranel em piso impermeável, área descoberta (baia)",
      value: "Agranel em piso impermeável, área descoberta (baia)",
    },
    {
      label: "Agranel em solo, área coberta (baia)",
      value: "Agranel em solo, área coberta (baia)",
    },
    {
      label: "Agranel em solo, área descoberta (baia)",
      value: "Agranel em solo, área descoberta (baia)",
    },
    { label: "Bag", value: "Bag" },
    {
      label: "Bombona em piso impermeável, área coberta",
      value: "Bombona em piso impermeável, área coberta",
    },
    {
      label: "Bombona em solo, área coberta",
      value: "Bombona em solo, área coberta",
    },
    {
      label: "Bombona em solo, área descoberta",
      value: "Bombona em solo, área descoberta",
    },
    {
      label: "Caçamba com cobertura",
      value: "Caçamba com cobertura",
    },
    {
      label: "Caçamba sem cobertura",
      value: "Caçamba sem cobertura",
    },
    { label: "Fardo", value: "Fardo" },
    {
      label: "Lagoa com impermeabilização",
      value: "Lagoa com impermeabilização",
    },
    {
      label: "Lagoa sem impermeabilização",
      value: "Lagoa sem impermeabilização",
    },
    {
      label: "Outros sistemas",
      value: "Outros sistemas",
    },
    {
      label: "Saco (exceto Bag)",
      value: "Saco (exceto Bag)",
    },
    {
      label: "Tambor em piso impermeável área coberta",
      value: "Tambor em piso impermeável área coberta",
    },
    {
      label: "Tambor em piso impermeável área Descoberta",
      value: "Tambor em piso impermeável área Descoberta",
    },
    {
      label: "Tambor em solo, área coberta",
      value: "Tambor em solo, área coberta",
    },
    {
      label: "Tanque com bacia de contenção",
      value: "Tanque com bacia de contenção",
    },
    {
      label: "Tanque sem bacia de contenção",
      value: "Tanque sem bacia de contenção",
    },
  ]);

  const [optionsTipoDestinacao] = useState([
    { label: "SELECIONE", value: "0" },
    {
      label: "Área de transbordo de resíduos (exceto de RCC e volumosos)",
      value: "Área de transbordo de resíduos (exceto de RCC e volumosos)",
    },
    {
      label: "Aterro de resíduo não perigoso - Classe II",
      value: "Aterro de resíduo não perigoso - Classe II",
    },
    {
      label: "Aterro de resíduo perigoso - Classe I",
      value: "Aterro de resíduo perigoso - Classe I",
    },
    {
      label: "Aterro de resíduos classe A",
      value: "Aterro de resíduos classe A",
    },
    { label: "Aterro sanitário", value: "Aterro sanitário" },
    {
      label: "ATT - Área de transbordo e triagem de RCC e volumosos",
      value: "ATT - Área de transbordo e triagem de RCC e volumosos",
    },
    {
      label: "ATT - Área de Transbordo e Triagem, associada à recicladora",
      value: "ATT - Área de Transbordo e Triagem, associada à recicladora",
    },
    {
      label:
        "ATT - Área de Transbordo e Triagem, associada ao aterro de resíduo classe A",
      value:
        "ATT - Área de Transbordo e Triagem, associada ao aterro de resíduo classe A",
    },
    {
      label: "Coleta pública de resíduos sólidos urbanos",
      value: "Coleta pública de resíduos sólidos urbanos",
    },
    {
      label: "Coprocessamento em fornos de cimento",
      value: "Coprocessamento em fornos de cimento",
    },
    {
      label: "Estação de tratamento de esgoto",
      value: "Estação de tratamento de esgoto",
    },
    {
      label: "Formulação de 'blend' de resíduos",
      value: "Formulação de 'blend' de resíduos",
    },
    { label: "Incinerador", value: "Incinerador" },
    {
      label: "Incorporação em solo agrícola",
      value: "Incorporação em solo agrícola",
    },
    { label: "Neutralização", value: "Neutralização" },
    {
      label: "ONG - Organização não governamental / Entidade Filantrópica",
      value: "ONG - Organização não governamental / Entidade Filantrópica",
    },
    { label: "Outra obra", value: "Outra obra" },
    { label: "Outras destinações", value: "Outras destinações" },
    {
      label: "PEV - Ponto de entrega voluntária",
      value: "PEV - Ponto de entrega voluntária",
    },
    {
      label: "PEV - Ponto de entrega voluntária, associado à recicladora",
      value: "PEV - Ponto de entrega voluntária, associado à recicladora",
    },
    {
      label:
        "PEV - Ponto de entrega voluntária, associado ao aterro de resíduo classe A",
      value:
        "PEV - Ponto de entrega voluntária, associado ao aterro de resíduo classe A",
    },
    {
      label: "Reciclagem externa de RCC classe A",
      value: "Reciclagem externa de RCC classe A",
    },
    {
      label: "Reprocessamento de óleo lubrificante (inclui rerrefino)",
      value: "Reprocessamento de óleo lubrificante (inclui rerrefino)",
    },
    {
      label: "Reutilização/Reciclagem externa exceto classe A",
      value: "Reutilização/Reciclagem externa exceto classe A",
    },
    {
      label: "Reutilização/Reciclagem interna",
      value: "Reutilização/Reciclagem interna",
    },
    { label: "Sucateiro intermediário", value: "Sucateiro intermediário" },
    {
      label: "Tratamento biológico: Biopilhas",
      value: "Tratamento biológico: Biopilhas",
    },
    {
      label: "Tratamento térmico sem combustão (autoclave, microondas, ETD)",
      value: "Tratamento térmico sem combustão (autoclave, microondas, ETD)",
    },
    {
      label: "Tratamento térmico: dessorção térmica",
      value: "Tratamento térmico: dessorção térmica",
    },
    { label: "Usina de compostagem", value: "Usina de compostagem" },
    { label: "Utilização em caldeira", value: "Utilização em caldeira" },
    {
      label: "Utilização em forno industrial (exceto em fornos de cimento)",
      value: "Utilização em forno industrial (exceto em fornos de cimento)",
    },
  ]);

  const [optionsDetalhamento] = useState([
    { label: "SELECIONE", value: "0" },
    { label: "Simplificado", value: "Simplificado" },
    { label: "Por Origem/fase", value: "Por Origem/fase" },
  ]);

  const [optionsOrigemEtapa] = useState([
    { label: "SELECIONE", value: "0" },
    { label: "Limpeza de Terreno", value: "Limpeza de Terreno" },
    { label: "Demolição", value: "Demolição" },
    { label: "Instalação de Canteiro", value: "Instalação de Canteiro" },
    { label: "Movimento de Terra", value: "Movimento de Terra" },
    { label: "Fundação", value: "Fundação" },
    { label: "Estrutura", value: "Estrutura" },
    { label: "Vedação", value: "Vedação" },
    { label: "Instalação Predial", value: "Instalação Predial" },
    { label: "Revestimento", value: "Revestimento" },
    { label: "Cobertura", value: "Cobertura" },
    { label: "Outros", value: "Outros" },
  ]);

  const { register, handleSubmit, errors, reset, control, watch } = useForm({
    mode: "onBlur",
    defaultValues: {
      detalhamento: optionsDetalhamento[0] || {
        label: "SELECIONE",
        value: "0",
      },
      fase: optionsOrigemEtapa[0] || {
        label: "SELECIONE",
        value: "0",
      },
      descricao: optionsClassesResiduo[0] || {
        label: "SELECIONE",
        value: "0",
      },
      volumeMes: "",
      armazenamentoObra: optionsArmazenamentoObra[0] || {
        label: "SELECIONE",
        value: "0",
      },
      tipoDestinacao: optionsTipoDestinacao[0] || {
        label: "SELECIONE",
        value: "0",
      },
    },
  });

  const getModeloDetalhadoData = () => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";
    const modeloDetalhadoList = isRequerimento
      ? item?.requerimentoGerador?.[0]
          ?.requerimentoGeradorDetalhamentoPlanoResiduos
      : item?.protocoloGerador?.[0]?.protocoloGeradorDetalhamentoPlanoResiduos;

    setDetalhamentosLista(modeloDetalhadoList);
  };

  // Classes de Resíduo
  async function loadOptionsClassesResiduo(categoria_Id) {
    try {
      setLoading(true);
      const { data } = await api_GET(
        `ClasseResiduo/GetListAtivosByCategoria/${categoria_Id}`
      );
      let _data = (data || []).map((value) => {
        return {
          label: value.descricao,
          value: value.descricao,
        };
      });
      set_OptionsClassesResiduo([{ label: "SELECIONE", value: "0" }, ..._data]);
    } catch (error) {
      showMessage(
        "Error",
        error?.message ?? "Error na operação",
        "error",
        null
      );
    } finally {
      setLoading(false);
    }
  }

  // Observar valor de tipoConstrucao
  const detalhamento = watch("detalhamento");

  function handleDeleteDetalhamento(rowData) {
    showQuestion(
      "Aviso",
      "Tem certeza que deseja remover este detalhamento?",
      "question",
      async function (retorno) {
        if (!retorno) return;

        const isRequerimento = opcao.tipoCadastro === "Requerimento";
        const index = rowData?.tableData?.id;

        setLoading(true);
        try {
          // Deleta da API se tiver ID
          if (isRequerimento) {
            const id = rowData?.requerimentoGeradorDetalhamentoPlanoResiduos_Id;
            if (id) {
              await api_DELETE(
                `RequerimentoGerador/DeleteRequerimentoGeradorDetalhamentoPlanoResiduo/${id}`
              );
            }
          } else {
            const id = rowData?.protocoloGeradorDetalhamentoPlanoResiduos_Id;
            if (id) {
              await api_DELETE(
                `ProtocoloGerador/DeleteProtocoloGeradorDetalhamentoPlanoResiduo/${id}`
              );
            }
          }

          // Remove do estado com base no index
          setDetalhamentosLista((prev) => prev.filter((_, i) => i !== index));

          // Atualiza o registro local também
          setRegistro((prevRegistro) => {
            const novoRegistro = { ...prevRegistro };

            if (isRequerimento) {
              novoRegistro.requerimentoGerador[0].requerimentoGeradorDetalhamentoPlanoResiduos =
                novoRegistro.requerimentoGerador[0].requerimentoGeradorDetalhamentoPlanoResiduos.filter(
                  (_, i) => i !== index
                );
            } else {
              novoRegistro.protocoloGerador[0].protocoloGeradorDetalhamentoPlanoResiduos =
                novoRegistro.protocoloGerador[0].protocoloGeradorDetalhamentoPlanoResiduos.filter(
                  (_, i) => i !== index
                );
            }

            return novoRegistro;
          });
        } catch (err) {
          showMessage(
            "Erro",
            err?.message ?? "Erro ao excluir detalhamento",
            "error",
            null
          );
        } finally {
          setLoading(false);
        }
      }
    );
  }

  function handleAdicionarDetalhamento(data) {
    if (!data?.detalhamento?.value || data?.detalhamento?.value === "0")
      return showMessage(
        "Aviso!",
        "Selecione o detalhamento da obra, por favor!",
        "warning",
        null
      );

    if (
      data?.detalhamento?.value === "Por Origem/fase" &&
      (!data?.fase?.value || data?.fase?.value === "0")
    )
      return showMessage(
        "Aviso!",
        "Selecione o origem/etapa, por favor!",
        "warning",
        null
      );

    if (!data?.descricao.value || data?.descricao?.value === "0")
      return showMessage(
        "Aviso!",
        "Selecione a descrição, por favor!",
        "warning",
        null
      );

    if (
      !data?.armazenamentoObra?.value ||
      data?.armazenamentoObra?.value === "0"
    )
      return showMessage(
        "Aviso!",
        "Selecione o armazenamento da obra, por favor!",
        "warning",
        null
      );

    if (!data?.tipoDestinacao?.value || data?.tipoDestinacao?.value === "0")
      return showMessage(
        "Aviso!",
        "Selecione o tipo da destinação, por favor!",
        "warning",
        null
      );

    if (!data.volumeMes || data.volumeMes <= 0)
      return showMessage(
        "Aviso!",
        "Informe o volume do mês, por favor!",
        "warning",
        null
      );

    const novoItem = {
      fase: data?.fase?.value,
      descricao: data.descricao.value,
      detalhamento: data.detalhamento.value,
      volumeMes: data.volumeMes,
      armazenamentoObra: data.armazenamentoObra.value,
      tipoDestinacao: data.tipoDestinacao.value,
    };

    const existe = detalhamentosLista.some(
      (item) => item.descricao === novoItem.descricao
    );

    if (existe) {
      return showMessage(
        "Aviso!",
        "Já tem um item com essa descrição!",
        "warning",
        null
      );
    }

    setDetalhamentosLista((prev) => [...prev, novoItem]);

    reset();
  }

  function handleCriarObjetoTipoRequerimento(detalhamentosLista) {
    const requerimentoGeradorId =
      registro?.requerimentoGerador?.[0]?.requerimentoGerador_Id;

    return {
      requerimentoGeradorDetalhamentoPlanoResiduos: detalhamentosLista.map(
        (item) => ({
          requerimentoGeradorDetalhamentoPlanoResiduos_Id:
            item.requerimentoGeradorDetalhamentoPlanoResiduos_Id ?? 0,
          requerimentoGerador_Id: requerimentoGeradorId,
          detalhamento: item.detalhamento,
          fase: item.fase,
          descricao: item.descricao,
          volumeMes: item.volumeMes,
          armazenamentoObra: item.armazenamentoObra,
          tipoDestinacao: item.tipoDestinacao,
        })
      ),
    };
  }

  function handleCriarObjetoTipoProtocolo(detalhamentosLista) {
    const protocoloGeradorId =
      registro?.protocoloGerador?.[0]?.protocoloGerador_Id;

    return {
      protocoloGeradorDetalhamentoPlanoResiduos: detalhamentosLista.map(
        (item) => ({
          protocoloGeradorDetalhamentoPlanoResiduos_Id:
            item.protocoloGeradorDetalhamentoPlanoResiduos_Id ?? 0,
          protocoloGerador_Id: protocoloGeradorId,
          detalhamento: item.detalhamento,
          fase: item.fase,
          descricao: item.descricao,
          volumeMes: item.volumeMes,
          armazenamentoObra: item.armazenamentoObra,
          tipoDestinacao: item.tipoDestinacao,
        })
      ),
    };
  }

  const onSubmit = async () => {
    if (detalhamentosLista.length === 0)
      return showMessage(
        "Aviso!",
        "Adicione pelo menos um detalhamento antes de continuar.",
        "warning",
        null
      );

    const isRequerimento = opcao.tipoCadastro === "Requerimento";
    setLoading(true);

    try {
      let detalhamentosSalvos = [];

      if (isRequerimento) {
        const objetoRequerimento =
          handleCriarObjetoTipoRequerimento(detalhamentosLista);

        for (const item of objetoRequerimento.requerimentoGeradorDetalhamentoPlanoResiduos) {
          let resposta;
          if (!item.requerimentoGeradorDetalhamentoPlanoResiduos_Id) {
            resposta = await api_POST(
              "RequerimentoGerador/PostRequerimentoGeradorDetalhamentoPlanoResiduo",
              item
            );
          } else {
            resposta = await api_PUT(
              "RequerimentoGerador/PutRequerimentoGeradorDetalhamentoPlanoResiduo",
              item
            );
          }

          if (resposta?.data) {
            detalhamentosSalvos.push(resposta.data);
          }
        }

        const registroAtualizado = { ...registro };
        if (registroAtualizado.requerimentoGerador?.[0]) {
          registroAtualizado.requerimentoGerador[0].requerimentoGeradorDetalhamentoPlanoResiduos =
            detalhamentosSalvos;
        }

        handleProximoStep(registroAtualizado);
      } else {
        const objetoProtocolo =
          handleCriarObjetoTipoProtocolo(detalhamentosLista);

        for (const item of objetoProtocolo.protocoloGeradorDetalhamentoPlanoResiduos) {
          let resposta;
          if (!item.protocoloGeradorDetalhamentoPlanoResiduos_Id) {
            resposta = await api_POST(
              "ProtocoloGerador/PostProtocoloGeradorDetalhamentoPlanoResiduo",
              item
            );
          } else {
            resposta = await api_PUT(
              "ProtocoloGerador/PutProtocoloGeradorDetalhamentoPlanoResiduo",
              item
            );
          }

          if (resposta?.data) {
            detalhamentosSalvos.push(resposta.data);
          }
        }

        const registroAtualizado = { ...registro };
        if (registroAtualizado.protocoloGerador?.[0]) {
          registroAtualizado.protocoloGerador[0].protocoloGeradorDetalhamentoPlanoResiduos =
            detalhamentosSalvos;
        }

        handleProximoStep(registroAtualizado);
      }
    } catch (error) {
      showMessage("Erro", error?.message ?? "Erro na operação", "error", null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      session != null &&
      session.tipoAcesso === "AreaRestrita" &&
      item != null
    )
      set_permiteEditar(true);

    if (item) {
      setRegistro(item);
      getModeloDetalhadoData();

      if (opcao.tipoCadastro === "Requerimento")
        loadOptionsClassesResiduo(
          item.setupSolicitacaoAcao.setupSolicitacao.categoria_Id
        );
      else
        loadOptionsClassesResiduo(
          item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria_Id
        );
    }
  }, [item]);

  return (
    <Card className="card-stats">
      <CardBody>
        <Container style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <Form>
            <h2 className="titulo-solicitacao">
              Plano de Resíduos - Detalhamento
            </h2>

            <Row>
              <Col
                md="12"
                lg={detalhamento?.value === "Por Origem/fase" ? "6" : "12"}
              >
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Detalhamento</label>
                  </b>
                  <Controller
                    name="detalhamento"
                    control={control}
                    rules={{ required: true }}
                    as={
                      <Select
                        options={optionsDetalhamento}
                        placeholder="Selecione"
                      />
                    }
                  />

                  {errors.detalhamento && (
                    <span className="form-control-label text-danger">
                      * Campo obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              {/* Fase */}
              {detalhamento && detalhamento?.value === "Por Origem/fase" && (
                <Col md="12" lg="6">
                  <FormGroup>
                    <b>
                      <span className="text-danger">* </span>{" "}
                      <label>Origem/Etapa</label>
                    </b>
                    <Controller
                      name="fase"
                      control={control}
                      rules={{ required: true }}
                      as={
                        <Select
                          options={optionsOrigemEtapa}
                          placeholder="Selecione"
                        />
                      }
                    />
                    {errors.fase && (
                      <span className="form-control-label text-danger">
                        * Campo obrigatório
                      </span>
                    )}
                  </FormGroup>
                </Col>
              )}

              {/* Descrição */}
              <Col md="12" lg={"6"}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">*</span> Descrição
                    </label>
                  </b>
                  <Controller
                    name="descricao"
                    control={control}
                    rules={{ required: true }}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    as={
                      <Select
                        options={optionsClassesResiduo}
                        placeholder="Selecione"
                      />
                    }
                  />

                  {errors.descricao && (
                    <span className="form-control-label text-danger">
                      * Campo obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              {/* Volume por Mês */}
              <Col md="12" lg="6">
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Volume (m³/mês)</label>
                  </b>
                  <Input
                    type="number"
                    name="volumeMes"
                    innerRef={register({
                      required:
                        session !== null &&
                        session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    autoComplete="off"
                    min="0"
                  />
                  {errors.volumeMes && (
                    <span className="form-control-label text-danger">
                      * Campo obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              {/* Armazenamento na Obra */}
              <Col md="12" lg="4">
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Armazenamento na Obra</label>
                  </b>
                  <Controller
                    name="armazenamentoObra"
                    control={control}
                    rules={{ required: true }}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    as={
                      <Select
                        options={optionsArmazenamentoObra}
                        placeholder="Selecione"
                      />
                    }
                  />

                  {errors.armazenamentoObra && (
                    <span className="form-control-label text-danger">
                      * Campo obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              {/* Tipo de Destinação */}
              <Col md="12" lg="4">
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Tipo de Destinação</label>
                  </b>
                  <Controller
                    name="tipoDestinacao"
                    control={control}
                    rules={{ required: true }}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    as={
                      <Select
                        options={optionsTipoDestinacao}
                        placeholder="Selecione"
                      />
                    }
                  />
                  {errors.tipoDestinacao && (
                    <span className="form-control-label text-danger">
                      * Campo obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg="4" className="mt-3">
                <Button
                  color="primary"
                  type="submit"
                  className="w-100"
                  onClick={handleSubmit(handleAdicionarDetalhamento)}
                >
                  Adicionar <i className="fas fa-plus"></i>
                </Button>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <MaterialTable
                  title=""
                  columns={[
                    { title: "Origem/Etapa", field: "fase" },
                    { title: "Descrição", field: "descricao" },
                    { title: "M³	", field: "volumeMes" },
                    {
                      title: "Armazenamento na Obra",
                      field: "armazenamentoObra",
                    },
                    { title: "Tipo de Destinação", field: "tipoDestinacao" },
                  ]}
                  data={detalhamentosLista}
                  isLoading={false}
                  actions={[
                    {
                      icon: "delete",
                      tooltip: "Remover",
                      onClick: async (event, rowData) =>
                        handleDeleteDetalhamento(rowData),
                    },
                  ]}
                  localization={table_translate}
                  options={{
                    ...table_style,
                    actionsColumnIndex: -1,
                  }}
                />
              </Col>
            </Row>
          </Form>
          <Row>
            <Col lg="6" className="text-left">
              <Button
                color="secondary"
                onClick={() => handleStepAnterior(registro)}
                className="btn-mobile"
                type="button"
              >
                <i className="fas fa-chevron-left"></i> Voltar
              </Button>
            </Col>
            <Col lg="6" className="text-right">
              <Button
                color="success"
                className="btn-mobile"
                type="button"
                onClick={onSubmit}
              >
                Próxima Etapa <i className="fas fa-chevron-right"></i>
              </Button>
            </Col>
          </Row>
        </Container>
      </CardBody>
    </Card>
  );
}
